import React, { useEffect } from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Redirect
} from "react-router-dom";
import { useSelector  } from 'react-redux';

// componentes
import Login from './Login';
import Painel from './Painel';
import ExigeInstalacao from './Login/ExigeInstalacao';

// funcoes
import { abertaComoAplicativo } from './Funcoes/instalacao';

function Sistema({

}){

    // reducers
    let loginReducer = useSelector(state => state.loginReducer);
    
    console.log(loginReducer);

    // so' pelo aplicativo instalado (20/10/2026): numa aba do navegador aparece so' o botao de instalar; em desenvolvimento libera
    if(process.env.NODE_ENV === 'production' && !abertaComoAplicativo()){
        return <ExigeInstalacao />;
    }

    return <>
        <Router>
            <Switch>
                <Route path={`/login`}>
                    { loginReducer.logado ? <Redirect to="/painel" /> : <Login /> }
                </Route>
                <Route path={`/painel`}>
                    { loginReducer.logado ? <Painel /> : <Redirect to="/login" /> }
                </Route>
                <Route path={`/`}>
                    <Redirect to='/painel' />
                </Route>
            </Switch>
        </Router>
    </>
}

export default Sistema;